<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#4A6592">
        <path
          d="M6.5 0C10.09 0 13 2.91 13 6.5c0 1.615-.589 3.092-1.564 4.229l3.418 3.417c.195.196.195.512 0 .708-.174.173-.443.192-.638.057l-.07-.057-3.417-3.418C9.592 12.411 8.115 13 6.5 13 2.91 13 0 10.09 0 6.5S2.91 0 6.5 0zm0 1C3.462 1 1 3.462 1 6.5S3.462 12 6.5 12 12 9.538 12 6.5 9.538 1 6.5 1z"
          transform="translate(0 1)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'SearchIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
